<div>
  @for (err of validationSummary?.errors; track err) {
    <ul>
      <li>{{err.message}}</li>
    </ul>
  }
</div>
